module.exports = __webpack_public_path__ + "static/img/i-hospital.9bef6b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/home/i-hospital.jpg
// module id = /3Y5
// module chunks = 1